export default "__VITE_ASSET__M_8724c$__"